import script from "./actions.vue?vue&type=script&setup=true&lang=js"
export * from "./actions.vue?vue&type=script&setup=true&lang=js"

import "./actions.vue?vue&type=style&index=0&id=f4b81576&lang=css"

const __exports__ = script;

export default __exports__